<template>
  <div class="identification-base">
    <el-form :model="form" :rules="rules" ref="form">
      <div class="tag-container">
        <div class="title">
          {{ $t('crm_identification_base.ji_chu_xin_xi') }}
        </div>
        <div class="content">
          <div class="left">
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('crm_identification_base.gong_si_ming_cheng')" prop="partnerName">
                  <el-input v-model="form.partnerName" :placeholder="$t('Common.com_please_input')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('crm_identification_base.gong_si_bian_hao')" prop="partnerCode">
                  <el-input v-model="form.partnerCode" :placeholder="$t('Common.com_please_input')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('crm_identification_base.tyshxydmyyzzbh')" prop="businessLicense">
                  <el-input v-model.trim="form.businessLicense" :placeholder="$t('Common.com_please_input')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('crm_identification_base.nsrsbhswdjbh')" prop="buyerNumber">
                  <el-input v-model.trim="form.buyerNumber" :placeholder="$t('Common.com_please_input')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('crm_identification_base.gong_si_di_zhi')" prop="detailAddress">
                  <custom-address-select :placeholder="$t('Common.com_please_select')" v-model="form.address" ref="address"></custom-address-select>
                  <el-input v-model="form.detailAddress" type="textarea" class="company-address"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="right">
            <div class="file-content">
              <div class="header">
                <div class="name">
                  {{ $t('crm_identification_base.ying_ye_zhi_zhao') }}
                </div>
                <div
                  v-if="funcView.company_ocr"
                  class="ocr"
                  @click="
                    onOCR('license', {
                      company: 'name',
                      businessLicense: 'regCode',
                      buyerNumber: 'regCode',
                      detailAddress: 'address',
                      legalPerson: 'legalPerson',
                    })
                  "
                >
                  {{ $t('crm_identification_base.OCRshi_bie_nei_rong') }}
                </div>
              </div>
              <file-upload
                ref="license"
                :text="$t('crm_identification_base.scyyzz')"
                :contentStyle="{
                  width: '100%',
                  height: '200px',
                  'padding-top': '79px',
                }"
                v-model="imageLicense"
                bizType="crm.partner.license"
                :bizId="partnerId"
                :tips="$t('crm_identification_base.qsccsyjhjggsqdxbcg2M')"
                :autoUpload="false"
              ></file-upload>
            </div>
          </div>
        </div>
        <div class="common-tips">
          <i class="icon icon-tishi"></i>
          <span class="text">{{ $t('crm_identification_base.qhdysxxyyyzzxxyz') }}</span>
        </div>
        <div class="content">
          <div class="left">
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('crm_identification_base.gong_si_wang_zhi')" prop="website">
                  <el-input v-model="form.website" :placeholder="$t('Common.com_please_input')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('crm_identification_base.gong_si_dian_hua')" prop="telephone">
                  <el-input v-model="form.telephone" :placeholder="$t('Common.com_please_input')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-row :gutter="8">
                  <el-col :span="16">
                    <el-form-item :label="$t('crm_identification_base.zhu_ce_zi_jin')" prop="registeredCapital">
                      <el-input v-model="form.registeredCapital" type="number" :min="0" :placeholder="$t('Common.com_please_input')"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('crm_identification_base.dan_wei')" prop="currencyUnit">
                      <custom-select v-model="form.currencyUnit" code="isynergy_cloud_currency" :placeholder="$t('Common.com_please_select')"></custom-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <div class="right">
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('crm_identification_base.gong_si_gui_mo')" prop="partnerScale">
                  <custom-select v-model="form.partnerScale" code="crm_partner_scale" :placeholder="$t('crm_identification_base.qxzgsgm')"></custom-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('crm_identification_base.gong_si_you_xiang')" prop="email">
                  <el-input v-model="form.email" :placeholder="$t('Common.com_please_input')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="tag-container">
        <div class="title">
          {{ $t('crm_identification_base.fa_ren_xin_xi') }}
        </div>
        <div class="content">
          <div class="left">
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('crm_identification_base.fa_ren_xing_ming')" prop="legalPerson" :rules="rules.legalPerson">
                  <el-input v-model="form.legalPerson" :placeholder="$t('Common.com_please_input')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('crm_identification_base.frsfz')" prop="legalPersonIdentity">
                  <el-input v-model="form.legalPersonIdentity" :placeholder="$t('Common.com_please_input')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="right">
            <div class="file-content">
              <div class="header">
                <div class="name">
                  {{ $t('crm_identification_base.frsfz') }}
                </div>
              </div>
              <div class="both">
                <file-upload
                  ref="imageIdFace"
                  :bizId="partnerId"
                  bizType="crm.id.face"
                  v-model="imageIdFace"
                  :text="$t('crm_identification_base.sfzrxm')"
                  :contentStyle="{
                    width: '199px',
                    height: '120px',
                    'padding-top': '37px',
                    float: 'left',
                  }"
                  :autoUpload="false"
                ></file-upload>
                <file-upload
                  ref="imageIdReverse"
                  :bizId="partnerId"
                  bizType="crm.id.reverse"
                  v-model="imageIdReverse"
                  :text="$t('crm_identification_base.sfzghm')"
                  :contentStyle="{
                    width: '199px',
                    height: '120px',
                    'padding-top': '37px',
                    float: 'right',
                  }"
                  :autoUpload="false"
                ></file-upload>
              </div>
              <div class="tips mt-6">
                {{ $t('crm_identification_base.qscqxdsfzzgsqdxbcg2M') }}
              </div>
            </div>
          </div>
        </div>
        <div class="common-tips mt-24 mb-0">
          <i class="icon icon-tishi"></i>
          <span class="text">{{ $t('crm_identification_base.qhdysxxyyyzzsfzxxyz') }}</span>
        </div>
      </div>
      <div class="tag-container">
        <div class="title">
          {{ $t('crm_identification_base.dgzhxx') }}
        </div>
        <div class="content">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item :label="$t('crm_identification_base.zhang_hao')" prop="depositNumber">
                <el-input v-model="form.depositNumber" :placeholder="$t('Common.com_please_input')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('crm_identification_base.kai_hu_yin_hang')" prop="depositBank">
                <el-input v-model="form.depositBank" :placeholder="$t('Common.com_please_input')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>
    <div class="footer mt-24">
      <el-button @click="pre">{{ $t('crm_identification_base.sybtyxy') }}</el-button>
      <el-button type="primary" @click="onSave">{{ $t('crm_identification_base.xybxzrzfs') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import fileUpload from '@/components/singleFileUpload.vue';
import customAddressSelect from '@/components/customAddressSelect.vue';

export default {
  components: {
    fileUpload,
    customAddressSelect,
  },
  inject: ['pre', 'next'],
  data() {
    return {
      companyId: '',
      form: {
        // 总部 HQ 售后公司SC 总代理 JV 大客户CO 公司CS
        partnerType: 'CS',
        // 1-企业，2-个体工商户，3-事业单位，4-宗教活动场所，5-其他
        enterpriseType: '1',
        // 统一社会信用代码/营业执照编号
        businessLicense: '',
        // 纳税人识别号/税务登记编号
        buyerNumber: '',
        // 公司名称
        partnerName: '',
        // 公司编号
        partnerCode: '',
        // 公司类型
        // companyType: '',
        // 公司电话
        telephone: '',
        // 公司邮箱
        email: '',
        // 公司规模
        partnerScale: '',
        // 注册资金
        registeredCapital: '',
        // 注册资金单位
        currencyUnit: '',
        // 公司网址
        website: '',
        // 公司地址
        address: [],
        // 公司详细地址
        detailAddress: '',
        // 法人姓名
        legalPerson: '',
        // 法人身份证
        legalPersonIdentity: '',
        // // 开户行
        // bankCode: '',
        // // 银行名称
        // bankName: '',
        // 账号
        depositNumber: '',
        // 开户银行
        depositBank: '',
        // 公司描述
        partnerDesc: '',
        bankcardId: '',
        extendId: '',
        country: '',
        province: '',
        city: '',
        countryCode: '',
        provinceCode: '',
        cityCode: '',
        timeZone: '',
      },
      imageLicense: [],
      imageIdFace: [],
      imageIdReverse: [],

      partnerId: '',
    };
  },

  computed: {
    rules() {
      return {
        businessLicense: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 18,
            message: this.$t('Common.com_rules_length_max', [18]),
          },
        ],
        buyerNumber: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        partnerName: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 50,
            message: this.$t('Common.com_rules_length_max', [50]),
          },
        ],
        telephone: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 15,
            message: this.$t('Common.com_rules_length_max', [15]),
          },
        ],
        email: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 50,
            message: this.$t('Common.com_rules_length_max', [50]),
          },
        ],
        partnerScale: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        website: {
          max: 100,
          message: this.$t('Common.com_rules_length_max', [100]),
        },
        detailAddress: { validator: this.checkAddress, required: true },
        legalPerson: {
          max: 50,
          message: this.$t('Common.com_rules_length_max', [50]),
        },
        legalPersonIdentity: {
          max: 50,
          message: this.$t('Common.com_rules_length_max', [50]),
        },
        bankCode: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        depositNumber: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        depositBank: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
  },
  methods: {
    checkAddress(rule, value, cb) {
      if (this.form.detailAddress.length > 100) {
        cb(new Error(this.$t('crm_identification_base.cdzc100gzf')));
        return;
      }
      if (!this.form.detailAddress || !this.form.detailAddress.trim()) {
        cb(new Error(this.$t('Common.com_required')));
        return;
      }
      if (!this.form.address.length) {
        cb(new Error(this.$t('Common.com_required')));
        return;
      }
      cb();
    },
    companyAddressDataFilter(list) {
      list.forEach((country) => {
        (country.children || []).forEach((province) => {
          (province.children || []).forEach((city) => {
            city.children = null;
          });
        });
      });
      return list;
    },
    onOCR(refName, keyMap) {
      this.$refs[refName].ocr().then((data) => {
        Object.keys(keyMap).forEach((key) => {
          this.form[key] = data[keyMap[key]];
        });
      });
    },
    getCompanyDetail() {
      this.$getJSON(apis.partnerInfo, { partnerId: this.partnerId }).then((res) => {
        const data = res.data;

        this.$setFormatData(this.form, data);
        this.form.address = [];

        if (data.countryCode) {
          this.form.address.push(data.countryCode);
        }
        if (data.provinceCode) {
          this.form.address.push(data.provinceCode);
        }
        if (data.cityCode) {
          this.form.address.push(data.cityCode);
        }
      });
    },
    checkImg() {
      const e = new Error('');
      if (!this.imageLicense.length) {
        this.$message.error(this.$t('crm_identification_base.yyzzqydjzsbnwk'));
        return Promise.reject(e);
      }
      if (!this.imageIdFace.length) {
        this.$message.error(this.$t('crm_identification_base.sfzrxmbnwk'));
        return Promise.reject(e);
      }
      if (!this.imageIdReverse.length) {
        this.$message.error(this.$t('crm_identification_base.sfzghmbnwk'));
        return Promise.reject(e);
      }
      return null;
    },
    // onBankCode: function (item) {
    //   if (item) {
    //     this.form.bankName = item.bankName || '';
    //   } else {
    //     this.form.bankName = '';
    //   }
    // },
    getReqData() {
      const addressMsg = this.$refs.address.getAddressMsg();
      this.$setFormatData(this.form, addressMsg);
      // 图片保存
      this.form.partnerInstructionList = [...this.imageLicense, ...this.imageIdFace, ...this.imageIdReverse];
      // 保存交互
      this.form.partnerId = this.partnerId;
      return this.form;
    },
    async onSave() {
      try {
        const uploadList = [this.$refs.license.submit(), this.$refs.imageIdFace.submit(), this.$refs.imageIdReverse.submit()];
        await Promise.all(uploadList);
        // await this.checkImg();

        this.$refs.form.validate(async (val) => {
          if (val) {
            await this.$postJSON(apis.partnerUpdate, this.getReqData());
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });

            this.next();
          }
        });
      } catch (e) {
        //
      }
    },
  },
  mounted() {
    this.partnerId = this.getJump('partnerId');
    this.getCompanyDetail();

    this.getFuncView('/companyInfo/msg');
  },
};
</script>

<style lang="scss" scoped>
.identification-base {
  padding-bottom: 20px;

  .mt-24 {
    margin-top: 24px !important;
  }

  .mt-6 {
    margin-top: 6px !important;
  }

  .mb-0 {
    margin-bottom: 0 !important;
  }

  .tag-container {
    border: 1px solid #ebebeb;
    padding: 35px 24px 24px 24px;
    position: relative;
    margin-top: 35px;
    .title {
      position: absolute;
      padding: 0 10px;
      color: #0d9ae0;
      font-size: 12px;
      font-weight: bold;
      top: -10px;
      left: 16px;
      background: #fff;
      line-height: 20px;
    }
    .content {
      overflow: hidden;
      .left,
      .right {
        width: 414px;
      }
      .left {
        float: left;
      }
      .right {
        float: right;
        .file-content {
          overflow: hidden;
          .header {
            overflow: hidden;
            .name {
              float: left;
              color: #495057;
              font-weight: bold;
            }
            .ocr {
              float: right;
              color: #0d9ae0;
              text-decoration: underline;
              cursor: pointer;
            }
            .name,
            .ocr {
              font-size: 12px;
              line-height: 24px;
              margin-bottom: 4px;
            }
          }
          .both {
            overflow: hidden;
          }
          > .tips {
            color: #aeb5bd;
            font-size: 12px;
            line-height: 16px;
            margin-top: 16px;
          }
        }
      }
      .company-address {
        margin-top: 8px;
      }
    }

    .common-tips {
      background: rgba(13, 154, 224, 0.15);
      height: 28px;
      line-height: 28px;
      padding-left: 10px;
      font-size: 12px;
      margin-top: 6px;
      margin-bottom: 24px;
      .icon {
        color: #0d9ae0;
      }
      .text {
        padding-left: 10px;
        color: #6c757d;
      }
    }
  }
}
</style>
